import { FC, useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PageHeader } from '../../../../Shared/PageHeader/PageHeader';
import User from '../../../../Data/User';
import { fetchUsers } from '../../../../Services/UserService';
import { userRoles } from '../../../../Utils/userRoles';
import { dictionary } from '../../../../dictionary';
import { routes } from '../../../../Utils/routes';
import { VendorsTable } from './VendorUsersTable';
import { LinkButton } from '../../../../Shared/buttons/LinkButton';
import { currentUserIsAdminForAtLeastOneHospital } from '../../../../redux/user/userSelectors';
import { If } from '../../../../Shared/If';
import { TabInfo } from '../../../../Shared/Tabs/Tabs';

export const VendorUsersIndex: FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [showArchived, setShowArchived] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const onVendorRowClick = (user: User) => history.push(routes.users.vendors.edit(user.id));
  const showCreateButton = useSelector(currentUserIsAdminForAtLeastOneHospital);

  useEffect(() => {
    (async () => {
      const fetchedUsers = await fetchUsers(userRoles.vendor);
      if (fetchedUsers) {
        setUsers(fetchedUsers);
        setIsLoading(false);
      }
    })();
  }, []);

  const filteredUsers = users.filter((u) => u.archived === showArchived);

  const usersTabs: TabInfo[] = useMemo(() => [
    { title: dictionary.ACTIVE_TAB_LABEL, active: !showArchived, onClick: () => setShowArchived(false) },
    { title: dictionary.DEACTIVATED_TAB_LABEL, active: showArchived, onClick: () => setShowArchived(true) },
  ], [showArchived]);

  return (
    <>
      <PageHeader title={dictionary.VENDOR_USERS} tabs={usersTabs}>
        <If condition={showCreateButton}>
          <LinkButton to={routes.users.vendors.create} data-testid="create-vendor-user">
            {dictionary.CREATE_NEW_VENDOR_USER}
          </LinkButton>
        </If>
      </PageHeader>

      <VendorsTable users={filteredUsers} isLoading={isLoading} onRowClick={onVendorRowClick} />
    </>
  );
};
